import React, { FC } from 'react';

/**
 * "auto_awesome" sparkle (one large + two small four-point stars) filled with the AI purple→pink
 * gradient — the same glyph used by AIGradientBanner / AIGradientLink. Distinct from the Zakeke
 * three-point `Sparkles`. Size it from the parent via `> svg`.
 */
export const AiSparkles: FC<{ className?: string }> = ({ className }) => (
    <svg className={className} xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
        <g fill='url(#ai_sparkles_grad)'>
            <polygon points='11.5,9.5 9,4 6.5,9.5 1,12 6.5,14.5 9,20 11.5,14.5 17,12' />
            <polygon points='19,9 20.25,6.25 23,5 20.25,3.75 19,1 17.75,3.75 15,5 17.75,6.25' />
            <polygon points='19,15 17.75,17.75 15,19 17.75,20.25 19,23 20.25,20.25 23,19 20.25,17.75' />
        </g>
        <defs>
            <linearGradient id='ai_sparkles_grad' x1='0' y1='0' x2='24' y2='24' gradientUnits='userSpaceOnUse'>
                <stop stopColor='#7c3aed' />
                <stop offset='0.5' stopColor='#a855f7' />
                <stop offset='1' stopColor='#ec4899' />
            </linearGradient>
        </defs>
    </svg>
);

export default AiSparkles;
